// Vendor libraries
import { EventEmitter, SimpleChanges } from '@angular/core';
// Services
import { FeatureService } from 'EntitlementsApp/ts/features/feature-needed/feature.service';
import { StaticMenuService } from 'NewAngular/services/static-menus/static-menus.service';
// Components
import { FeatureNeededComponent } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.component';
import * as i0 from "@angular/core";
import * as i1 from "EntitlementsApp/ts/features/feature-needed/feature.service";
import * as i2 from "NewAngular/services/static-menus/static-menus.service";
/**
 * Metric Selector Modal Directive
 *
 * A modal that allows users to select metrics. This should not be used directly, instead us a component that extends
 * this directive.
 *
 * This component is extended by: SingleMetricSelectorModal, MultiMetricSelectorModal
 *
 * Inputs:
 *   metricMenuType: The type of metrics that should be shown
 *   searchType: The type of search results to display in the add button autocomplete in the modal.
 *   fetchCategories: Whether or not to call staticMenuService to fetch categories.
 *   showInfoPopover: Whether or not to show info popover for individual items.
 *
 * Outputs:
 *   selectMetricHandler: An event emitter that emits the selected metric.
 */
export class MetricSelectorModalDirective {
    constructor(featureService, staticMenuService) {
        this.featureService = featureService;
        this.staticMenuService = staticMenuService;
        this.fetchCategories = true;
        this.closeHandler = new EventEmitter();
        this.categories = [];
        this.showInfoPopover = true;
        this.MENU_TYPE = 'metricMenu';
        this.open = false;
    }
    ngOnChanges(changes) {
        if (this.fetchCategories) {
            // Depending on the `metricMenuType`, fetch different menu options to display
            if (changes.searchType?.currentValue && this.searchType) {
                this.metricMenuType = this.searchType.replace('_calc', '');
                this.staticMenuService
                    .getStaticMenu(this.MENU_TYPE, this.metricMenuType)
                    .subscribe((response) => {
                    this.categories = response;
                });
            }
        }
    }
    openModal() {
        this.resetModal();
        this.open = true;
    }
    closeModal() {
        this.open = false;
        this.closeHandler.emit();
    }
    resetModal() { }
    /**
     * Check that the user has the features needed for their selected metrics.
     * @param metrics: A list of objects describing metrics. These objects must contain `feature_needed`. This allows us
     *   to pass in arrays of Metric or AutocompleteResult.
     * @return A list of metrics that user has access to
     */
    validateFeatureNeeded(metrics) {
        const validMetrics = [];
        let firstMissingFeature = null;
        metrics.forEach((metric) => {
            if (this.featureService.userHasFeatures([metric.feature_needed])) {
                validMetrics.push(metric);
            }
            else if (firstMissingFeature === null) {
                firstMissingFeature = metric.feature_needed;
            }
        });
        if (firstMissingFeature !== null)
            this.featureNeededModal.openModal(firstMissingFeature);
        return validMetrics;
    }
}
MetricSelectorModalDirective.ɵfac = function MetricSelectorModalDirective_Factory(t) { return new (t || MetricSelectorModalDirective)(i0.ɵɵdirectiveInject(i1.FeatureService), i0.ɵɵdirectiveInject(i2.StaticMenuService)); };
MetricSelectorModalDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: MetricSelectorModalDirective, viewQuery: function MetricSelectorModalDirective_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(FeatureNeededComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.featureNeededModal = _t.first);
    } }, inputs: { searchType: "searchType", fetchCategories: "fetchCategories", categories: "categories", showInfoPopover: "showInfoPopover" }, outputs: { closeHandler: "closeHandler" }, features: [i0.ɵɵNgOnChangesFeature] });
